module.exports = __webpack_public_path__ + "img/coupon_era.6fa17c2d.png";